module.exports = __webpack_public_path__ + "static/media/ENS-101-badge.ccf19a5d.svg";